"use client";

export default function MarqueeBar() {
  const items = [
    "全屋裝修", "Full Home Renovation",
    "室內設計", "Interior Design",
    "廚房改造", "Kitchen Renovation",
    "浴室翻新", "Bathroom Renovation",
    "訂造傢俬", "Custom Furniture",
    "辦公室裝修", "Office Renovation",
    "天花地板", "Ceiling & Flooring",
    "燈光設計", "Lighting Design",
  ];

  const doubled = [...items, ...items];

  return (
    <div className="w-full overflow-hidden border-y py-5" style={{ borderColor: "rgba(212,175,55,0.2)", background: "rgba(26,47,94,0.3)" }}>
      <div className="flex whitespace-nowrap animate-marquee">
        {doubled?.map((item, i) => (
          <span key={`${item}-${i}`} className="flex items-center gap-6 px-6">
            <span className="text-xs font-bold uppercase tracking-widest" style={{ color: i % 2 === 0 ? "#D4AF37" : "rgba(245,240,232,0.5)" }}>
              {item}
            </span>
            <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: "rgba(212,175,55,0.4)" }} />
          </span>
        ))}
      </div>
    </div>
  );
}